const ADMIN_ROLE = "ROLE_ADMIN";

// Temporary fallback only. Prefer Java account authorities from `GET /api/account`.
const TEMP_ADMIN_USER_IDS = [];

function normalizeRoles(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value;
  }

  if (typeof value === "string") {
    return value
      .split(/[,+\s]+/)
      .map((role) => role.trim())
      .filter(Boolean);
  }

  return [];
}

function isAdminRole(role) {
  const normalizedRole = String(role || "").trim().toUpperCase();
  return normalizedRole === ADMIN_ROLE || normalizedRole === "ADMIN";
}

export function getUserRoles(user) {
  if (!user) {
    return [];
  }

  return [
    ...normalizeRoles(user.authorities),
    ...normalizeRoles(user.role),
    ...normalizeRoles(user.roles),
  ];
}

export function isAdminUser(user) {
  if (!user) {
    return false;
  }

  const roles = getUserRoles(user);
  if (roles.some(isAdminRole)) {
    return true;
  }

  return TEMP_ADMIN_USER_IDS.indexOf(Number(user.id)) !== -1;
}

export function isAdminAccessAllowed(authUser, trainer) {
  const trainerUser = trainer && trainer.user ? trainer.user : null;
  return isAdminUser(authUser) || isAdminUser(trainer) || isAdminUser(trainerUser);
}

export { ADMIN_ROLE, TEMP_ADMIN_USER_IDS };



// WEBPACK FOOTER //
// ./src/utils/adminAccess.js